import { Box, Button, Card, CardContent, Divider, TextField, Typography } from '@mui/material';
import ReadylyHeader from '../../components/ReadylyHeader/ReadylyHeader.jsx';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import { useTheme, useMediaQuery } from '@mui/material';
import { React, useState, useEffect } from 'react';
import logo from '../../images/readyly_logo.png'
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getOrgData } from '../../api';

const VerifyPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [subDomain, setSubDomain] = useState('');
    const orgDetails = useSelector((state) => state.auth.orgDetails);
    const orgid = orgDetails?._id;
    const ticketId = useSelector((state) => state.ticket.ticketId);
    const isOrgDataloading = useSelector((state) => state.auth.orgDetailsLoading);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    function handleOrganizationDetails() {
        dispatch(getOrgData(subDomain))
    }

    useEffect(() => {
        if (orgid) {
            const ticketingSystem = orgDetails?.ticketing?.platform;
            const newSearchParams = new URLSearchParams({
                subDomain: subDomain,
                ticketId: ticketId,
                ticketingSystem: ticketingSystem,
                email: "EMAIL"
            });
            navigate({
                pathname: '/app',
                search: newSearchParams.toString(),
            }, { replace: true });
        }
    }, [orgid, orgDetails, subDomain, ticketId, navigate])

    return (
        <div>
            <ReadylyHeader />
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: isMobile ? "90%" : "40%", marginTop: "10%", padding: "10px", borderRadius: "30px" }}>
                    <img src={logo} alt="Readyly Logo" width="15%" height="15%" />
                    <CardContent>
                        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                            Powering speed and accuracy
                        </Typography>
                    </CardContent>
                    <Divider sx={{ color: "text.primary" }} />
                    <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                        Please Provide Your Organization Name Below
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "center" }} >
                        <TextField required disabled={isOrgDataloading} label="Sub-Domain" variant="outlined" size="small" type="text" onChange={(e) => setSubDomain(e.target.value.trim())} sx={{ textTransform: "none", margin: "10px" }} error={subDomain === ""} />
                        <Button loading={isOrgDataloading} loadingPosition="end" variant="contained" sx={{ textTransform: "none", margin: "10px" }} endIcon={<VerifiedOutlinedIcon />} onClick={handleOrganizationDetails} disabled={subDomain === ""}>Verify Organization</Button>
                    </Box>
                </Card>
            </div>
        </div>
    )
}

export default VerifyPage